module.exports = __webpack_public_path__ + "video/B-A-005_SAF_BTB_PhishingInAction.0819027e.vtt";